import { render, staticRenderFns } from "./PHeader.vue?vue&type=template&id=c3cfd866&"
import script from "./PHeader.vue?vue&type=script&lang=ts&"
export * from "./PHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports